import * as types from '../types'

/**
 * 搜索数据
 * list: 搜索结果数据
 * hostList: 热门搜索
 * mySearchList: 我的搜索
 */
const state = {
    list: [],
    hotList: [
        '野猪杂交黑猪尾巴',
        '野猪杂交黑猪排骨',
        '无农药架豆',
        '河塘野生泥鳅',
        '无农药秀珍菇',
        '无农药菜椒',
        '无农药玉珍果',
        '无添加白吐司',
    ]
}

const getters = {

}

const mutations = {
    [types.CHANGE_SEARCH_LIST] (state, list) {
        state.list = list
    },

    [types.AJAX_UPDATE_SEARCH] (state, data) {
        state.list = state.list.concat(data)
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/search.js